import { createSelector } from 'reselect'

import { NAME } from './reducer'

const byIdSelector = (state) => state[NAME].byId
export const getSigEventIds = (state) => state[NAME].allKeys

export const getEventById = createSelector([byIdSelector], (byId) => (id) =>
  byId[id] || null
)

export const getEvents = createSelector(
  [getEventById, getSigEventIds],
  (byId, allKeys) => allKeys.map(byId)
)

export const getSigEventsIsLoading = (state) => state[NAME].sigEventsIsLoading

export const getSelectedEventIds = (state) => state[NAME].selected.eventIds
export const getCurrentSelectedIndex = (state) => state[NAME].selected.current

const getSelectedEventId = createSelector(
  [getSelectedEventIds, getCurrentSelectedIndex],
  (eventIds, current) => eventIds[current]
)

export const getAllSelectedEvents = createSelector(
  [getSelectedEventIds, getEventById],
  (eventIds, byId) => eventIds.map(byId)
)

export const getSelectedCount = createSelector(
  [getSelectedEventIds],
  (selectedIds) => selectedIds.length
)

export const getCurrentSelectedSigEvent = createSelector(
  [getSelectedEventId, getEventById],
  (eventId, byId) => byId(eventId)
)

export const getEditor = (state) => state[NAME].editor

/**** Incidents */

export const getIncidentIds = (state) => state[NAME].incidentKeys
const incidentByIdSelector = (state) => state[NAME].incidentsById
const incidentVisibilitySelector = (state) => state[NAME].incidentsVisible

export const getIncidentIsVisibleById = createSelector(
  [incidentVisibilitySelector],
  (byId) => (id) => byId[id] || false
)

export const getIncidentById = createSelector(
  [incidentByIdSelector, getIncidentIsVisibleById],
  (byId, isVisible) => (id) => {
    const incident = byId[id] || null
    if (incident !== null) {
      incident.visible = isVisible(id)
    }
    return incident
  }
)

export const getIncidents = createSelector(
  [getIncidentById, getIncidentIds],
  (byId, allKeys) => allKeys.map(byId)
)

export const getVisibleIncidentIds = createSelector(
  [getIncidentIds, getIncidentIsVisibleById],
  (ids, isVisible) => ids.filter(isVisible)
)
export const getVisibleIncidents = createSelector(
  [getIncidentById, getVisibleIncidentIds],
  (byId, allKeys) => allKeys.map(byId)
)

export const getVisibleEvents = createSelector(
  [getEvents, getIncidentIsVisibleById],
  (events, isVisible) => events.filter((e) => isVisible(e.incidentId))
)
